import React, { Component } from 'react';
import '../../App.css';
import BannerPrincipal from './banner-principal'
import BannerVideo from './banner-video'
import Row from '../reusables/row'
import Products from './products'
import Categories from './categories'
import Certifications from '../reusables/certifications'
import Footer from '../reusables/footer'

import videoprincipal from '../../video/video1.mp4'
import videorosas from '../../video/rose.mp4'
import videocamarones from '../../video/camarones.mp4'

class home extends Component {
  render() {
    return (
      <div className="home">
        {/* <Navbar/> */}
        <BannerPrincipal video={[videoprincipal]}
                title={['Pioricost Fruit']}
                linkto={["pioricost-fruit"]}
                description={['Debido a nuestra ubicación geográfica, el banano tiene "mayor tamaño, una consistencia más homogénea y un sabor diferente, y más intenso", por aquello el banano ecuatoriano es el mejor del mundo.']}/>
        <Row label={['Mensaje del Consejo Directivo']}
             description={['“El desarrollo de un país no es producto de la suerte, sino de decisiones políticas claras y correctas, de la mano con la innovación e la inversión privada, INEXLAM C.A se compromete a aportar y combinar estas métricas para el desarrollo de Ecuador”']}
             author={['Daniel Izurieta-Bayas']}
             charge={['Presidente y Director Ejecutivo de INEXLAM C.A.']}
             description2={['“El comercio, como actividad fundamental de todo país, incorpora no solo el intercambio de productos sino la implementación de relaciones sociales con socios estratégicos, INEXLAM C.A trabaja día a día por el fortalecimiento y crecimiento del comercio nacional e internacional”']}
             author2={['Jair Tovar']}
             charge2={['GERENTE GENERAL DE INEXLAM.C.A']}/>
        <Products/>
        <Row label={['Mensaje del Consejo Directivo']}
             description={['“El desarrollo de un país no es producto de la suerte, sino de decisiones políticas claras y correctas, de la mano con la innovación e la inversión privada, INEXLAM C.A se compromete a aportar y combinar estas métricas para el desarrollo de Ecuador”']}
             author={['Daniel Izurieta-Bayas']}
             charge={['Presidente y Director Ejecutivo de INEXLAM C.A.']}
             description2={['“El comercio, como actividad fundamental de todo país, incorpora no solo el intercambio de productos sino la implementación de relaciones sociales con socios estratégicos, INEXLAM C.A trabaja día a día por el fortalecimiento y crecimiento del comercio nacional e internacional”']}
             author2={['Jair Tovar']}
             charge2={['GERENTE GENERAL DE INEXLAM.C.A']}/>
        {/* <Banner image={[bannersecundario]}
                title={['Lorem ipsum dolor sit amet, consectetur']}
                description={['Adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.']}/> */}
        
        <BannerVideo video={[videocamarones]}
                title={['Pioricost Fish']}
                linkto={['']}
                description={['Frescura, tamaño, cuidado ambiental, calidad y factor social han sido los pilares que han llevado al camarón ecuatoriano a convertirse en el más demandado a nivel mundial, y destronando al banano, como el primer producto de exportación no petrolera del país.']}/>
        <Categories/>
        <Row label={['Mensaje del Consejo Directivo']}
             description={['“El desarrollo de un país no es producto de la suerte, sino de decisiones políticas claras y correctas, de la mano con la innovación e la inversión privada, INEXLAM C.A se compromete a aportar y combinar estas métricas para el desarrollo de Ecuador”']}
             author={['Daniel Izurieta-Bayas']}
             charge={['Presidente y Director Ejecutivo de INEXLAM C.A.']}
             description2={['“El comercio, como actividad fundamental de todo país, incorpora no solo el intercambio de productos sino la implementación de relaciones sociales con socios estratégicos, INEXLAM C.A trabaja día a día por el fortalecimiento y crecimiento del comercio nacional e internacional”']}
             author2={['Jair Tovar']}
             charge2={['GERENTE GENERAL DE INEXLAM.C.A']}/>
        <BannerVideo video={[videorosas]}
                title={['Pioricost Roses']}
                linkto={['']}
                description={['Tiendas tan exclusivas como Roseonly en China, han convertido a la rosa ecuatoriana en un símbolo de exclusividad, elegancia, buen gusto, variedad y sobre todo calidad. ']}/>
        <Certifications/>
        <Footer/>
      </div>
    );
  }
}

export default home;


// WEBPACK FOOTER //
// ./src/components/home/index.js